import { DndContext, DragOverlay, pointerWithin, useSensor, useSensors } from "@dnd-kit/core";
import { snapCenterToCursor } from '@dnd-kit/modifiers';
import clsx from 'clsx';
import { useEffect, useRef, useState } from "react";
import { MouseSensor, TouchSensor, } from './DndSensorsOverwrite';
import classes from './DragDrop.module.css';


import AppState from "@/js/AppState";
import Button from "@cmp/shared/Button/Button";
import { observer } from "mobx-react-lite";
import { FaXmark } from "react-icons/fa6";
import { DragDrop as DD } from "react-sdk/activities/DragDrop";
import ScaleManager from "react-sdk/ScaleManager";
import SoundPlayer from "react-sdk/SoundPlayer";
import Texts from "react-sdk/Texts";
// import ActivityLives from "../ActivityLives/ActivityLives";
import Bucket from "./Bucket/Bucket";
import Draggable from "./Draggable/Draggable";
import GridTargets from "./GridTargets/GridTargets";
import ImageTarget from "./ImageTarget/ImageTarget";
import { pickRandom } from "react-sdk/utils";
// import Catalogue from "@/js/Catalogue/Catalogue";


/**
* @param {object} props
* @param {DD} props.instance
*/
const DragDrop = ({instance, isDragDropImage, onReadyToValidate}) => {
  const ctnrRef = useRef(null)

  const [info_popup, setInfo_popup] = useState(null);

  const [step, setStep] = useState(0); // 0 : jeu, 1: corrections si vie , 2: correction finales, 3: bonnes réponses

  const [activeId, setActiveId] = useState(null);
  const [lives, setLives] = useState(1);
  const [corrects, setCorrects] = useState([]);
  const [height, setHeight] = useState(null);


  useEffect(() => {
    instance.reset()

    setStep(0)
    setActiveId(null)
    setCorrects([])
    setLives(1)
    setTimeout(() => {
      setHeight(ctnrRef.current.offsetHeight)
    }, 10)
  }, [instance]);

  const mouseSensor = useSensor(MouseSensor);
  const touchSensor = useSensor(TouchSensor);
  const sensors = useSensors( mouseSensor, touchSensor );

  function handleDragStart(data) {
    SoundPlayer.playSound("drapDrop_drag")
    setActiveId(data.active.id)
  }
  function handleDragEnd(data) {
    SoundPlayer.playSound("drapDrop_drop")
    if(!data.over) return // si on le lache en dehors d'un Droppable

    let proposition_id = data.active.id
    let target_id = data.over.id
    if(target_id === "bucket") {
      instance.place(proposition_id, null)
    }
    else {
      instance.place(proposition_id, target_id)

    }
  }

  function scaleModifier(args) {

    const {transform,} = args;

    return {
      ...transform,
      x: (transform.x / ScaleManager.scale) + (ScaleManager.marginPos === "left" ? ScaleManager.margin : 0),
      y: (transform.y / ScaleManager.scale) - (ScaleManager.marginPos === "top" ? ScaleManager.margin : 0)
    }
  }

  useEffect(() => {
    onReadyToValidate(instance.allPlaced && step === 0)
  }, [instance.allPlaced, step]);


  useEffect(() => {


    if(instance.result && step === 0) {

      setStep(1)

      let r = instance.result
      instance.result = null

      if(!r.is_correct) {
        if(lives > 1) {
          setStep(1)
          setLives(l => l-1)

          setTimeout(() => {
            instance.propositions.forEach(p => {
              if(!p.correct) p.placed = null
              else setCorrects(c => [...c, p.ID])
            })
            setStep(0)
          }, 2000)
          // ici on a encore assez de vies
          // show correction
          // attendre
          // delete result, gérer les corrects
        }
        else {
          setLives(l => l-1)
          setStep(1)
          setTimeout(() => {
            instance.result = r
            setStep(2)
          }, 2000)
        }
      }
      else {
        instance.result = r
        setStep(2)
      }
    }

  }, [instance.result]);

  useEffect(() => {
    if (step < 2)
      return

    instance.propositions.forEach(p => {
      if (p.catalogId) {
        let catItem = Catalogue.get(p.catalogId);
        if (catItem) {
          if(!p.correct)
            catItem.knowledge = -1;
          else
            catItem.knowledge = 1;
        }
      }
    })
  }, [step])
  // const nb_rows = Math.ceil(dd.targets.length / 2)
  return (
    <DndContext
    key={instance.ID}
    // autoScroll={false}
    sensors={sensors}
    collisionDetection={pointerWithin}
    onDragStart={handleDragStart}
    onDragEnd={handleDragEnd}>

      {AppState.debugMode &&
      <button style={{position: "fixed", top: 0, left: 0}} onClick={() => {
        instance.propositions.forEach((p ,i)=> p.placed = instance.targets.map(t => t.ID)[i])
      }}>placer dans l'ordre</button>}

      <div className={clsx(classes.DragDrop)} ref={ctnrRef} style={{height}}>
        {/* <div className={classes.lives}>
          <ActivityLives lives={lives} total={2} />
        </div> */}

        <Bucket with_media={instance.propositions.some(p => p.media)}>
          {instance.remainingPropositions.map(p =>
          <Draggable item={p} key={p.ID} />)}
        </Bucket>

        {!isDragDropImage &&
        <GridTargets dd={instance} step={step} corrects={corrects} />}

        {isDragDropImage &&
        <ImageTarget dd={instance}  step={step} corrects={corrects} />}
      </div>

      {step === 1 && <div className={classes.wait_correction}>La correction va s'afficher dans un instant</div>}

      {info_popup &&
      <div className={classes.info_popup}>
        <div>
          <Button onClick={() => setInfo_popup(null)} icon={<FaXmark />} className={classes.target_info_button} />
          <div dangerouslySetInnerHTML={{__html: Texts.parseMarkdown(info_popup, {noParagraph: true})}}></div>
        </div>
      </div>}

      <DragOverlay modifiers={[snapCenterToCursor, scaleModifier]} className={classes.drag_overlay_ctnr}>
        {activeId && <Draggable item={instance.getProposition(activeId)} dragged />}
      </DragOverlay>
    </DndContext>
  )
}

export default observer(DragDrop)


export const DragDropImage = observer(({instance, onReadyToValidate}) => {
  return <DragDrop instance={instance} onReadyToValidate={onReadyToValidate} isDragDropImage={true} />
})
